import { Filter, PageFilter } from "@/filters";

class GlobalVariablesClass {
    public lang = "";
    public filters: PageFilter | null = null;
}

export const GlobalVariables = new GlobalVariablesClass();